import { Box, Container } from "@/components/atoms";
import { Typography, Divider } from "@mui/material";
import { useUserContext } from "@/providers/contexts";
import {
  ErrorState,
  LoadingState,
  UnauthenticatedState,
} from "@/components/views";
import { FollowedCompaniesTable } from "./FollowedCompaniesTable";
import { SavedJobsTable } from "./SavedJobsTable";
import { UserAvatar } from "./UserAvatar";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { AboutSection } from "./AboutSection";
import { useEffect } from "react";

dayjs.extend(relativeTime);

export const Profile = () => {
  const {
    user,
    error,
    savedCompanies,
    savedJobs,
    loading,
    isAuthenticated,
    refetchUser,
    disabledBasicContent,
    disabledProContent,
  } = useUserContext();

  useEffect(() => {
    refetchUser();
  }, []);

  if (error) return <ErrorState errors={error} />;
  if (loading) return <LoadingState />;
  if (!isAuthenticated) return <UnauthenticatedState />;

  return (
    <Container componentName="profile" component="main" sx={{ my: 4 }}>
      <Box
        componentName="account-parent"
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          componentName="profile-upper"
          sx={{
            flex: 1,
            p: 2,
            borderRadius: 2,
            border: "none",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Box
            componentName="profile-avatar-name"
            flexDirection="column"
            rowGap={4}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              my: 2,
              border: "none",
            }}
          >
            <UserAvatar
              email={user?.email}
              firstName={user?.first_name}
              lastName={user?.last_name}
            />
            <Typography variant="h5" sx={{ ml: 2 }}>
              {user?.first_name || "First Name"}{" "}
              {user?.last_name || "Last Name"}
            </Typography>
          </Box>
          <Divider sx={{ mx: 2 }} orientation="vertical" />

          <AboutSection user={user} />
        </Box>

        <Box
          componentName="followed-saved-parent"
          border={false}
          sx={{ flex: 2, p: 2, mt: 2 }}
        >
          <Divider sx={{ my: 2 }} />

          <FollowedCompaniesTable
            savedCompanies={savedCompanies}
            refetchUser={refetchUser}
            isDisabled={disabledBasicContent || disabledProContent}
          />
          <Divider sx={{ my: 4 }} />
          <SavedJobsTable
            savedJobs={savedJobs}
            refetchUser={refetchUser}
            isDisabled={disabledBasicContent || disabledProContent}
          />
        </Box>
      </Box>
    </Container>
  );
};
